export default "__VITE_ASSET__XQdA8s8X_8azF7ZPjg1HrQ__";